// const API_BASE_URL = "http://localhost/school";
const API_BASE_URL = "https://rootsmontparent.gudstart.com/api";
const apiEndpoints = {
  register: `${API_BASE_URL}/register.php`,
  activity: `${API_BASE_URL}/activities.php`,
  attendance: `${API_BASE_URL}/attendance.php`,
  announcements: `${API_BASE_URL}/announcement.php`,
  validateToken: `${API_BASE_URL}/jwtautogenerate.php`,
  fees: `${API_BASE_URL}/fees.php`,
  progress: `${API_BASE_URL}/progress.php`,
    dashboard: `${API_BASE_URL}/dashboard.php`,
    calendar:`${API_BASE_URL}/calendar.php`,
};

export default apiEndpoints;
